import {
  GET_TOKEN,
  SET_TOKEN,
  TOGGLE_LOADING,
  HANDLE_SNACKBAR,
  SET_BADGE,
  GET_BADGE,
  HANDLE_MODAL,
  GET_OWNER,
  SET_ROLE,
  GET_ROLE,
  SET_PERMISSION,
  GET_PERMISSION,
  SET_CURRENT_USER,
  GET_CURRENT_USER, HANDLE_MODAL_CONDITIONS
} from 'redux/TypeConstant';

export const Set_Permission = (token) => {
  return {
    type: SET_PERMISSION,
    data: token,
  };
};

export const Get_Permission = () => {
  return {
    type: GET_PERMISSION,
  };
};

export const Set_Current_User = (user) => {
  return {
    type: SET_CURRENT_USER,
    data: user,
  };
};

export const Get_Current_User = () => {
  return {
    type: GET_CURRENT_USER,
  };
};

export const Set_Role = (role) => {
  return {
    type: SET_ROLE,
    data: role,
  };
};

export const Get_Role = () => {
  return {
    type: GET_ROLE,
  };
};

export const Get_Owner = () => {
  return {
    type: GET_OWNER,
  };
};

export const Set_Token = (token) => {
  return {
    type: SET_TOKEN,
    data: token,
  };
};

export const Get_Token = () => {
  return {
    type: GET_TOKEN,
  };
};

export const Loading = () => {
  return {
    type: TOGGLE_LOADING,
  };
};

export const showSnackbar = (show, severity = '', text = '') => {
  return {
    type: HANDLE_SNACKBAR,
    show,
    severity,
    text,
  };
};

export const showModalPassword = (show) => {
  return {
    type: HANDLE_MODAL,
    show,
  };
};

export const showModalCondition = (show) => {
  return {
    type: HANDLE_MODAL_CONDITIONS,
    show,
  };
};
